import {
  BacktestingExceptionsField,
  MapBacktestingExceptionsGridOptions,
} from 'shared/components/DataGrid/BacktestingExceptionsGrid/types';

export const mapBacktestingExceptionsGrid = ({
  data,
}: MapBacktestingExceptionsGridOptions): BacktestingExceptionsField[] => {
  return data.map(({ date, plNav, varHis, lossOvershooting }) => {
    return {
      date,
      plNav,
      varHis,
      lossOvershooting,
    };
  });
};
